import { render, staticRenderFns } from "./mallRightFloatingInfoConfigModal.vue?vue&type=template&id=608c992a&scoped=true"
import script from "./mallRightFloatingInfoConfigModal.vue?vue&type=script&lang=js"
export * from "./mallRightFloatingInfoConfigModal.vue?vue&type=script&lang=js"
import style0 from "./mallRightFloatingInfoConfigModal.vue?vue&type=style&index=0&id=608c992a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608c992a",
  null
  
)

export default component.exports